
seedWebServices.service('UtilsService', ['$http', '$uibModal',
    function ($http, $uibModal) {

        this.copyToClipboard = function (text) {
            console.log('Copiando para o clipboard: ' + text);
            if (window.clipboardData && window.clipboardData.setData) {
                return clipboardData.setData("Text", text);
            } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
                var textarea = document.createElement("textarea");
                textarea.textContent = text;
                textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
                document.body.appendChild(textarea);
                textarea.select();
                try {
                    return document.execCommand("copy");  // Security exception may be thrown by some browsers.
                } catch (ex) {
                    console.warn("Copy to clipboard failed.", ex);
                    return false;
                } finally {
                    document.body.removeChild(textarea);
                }
            }
        };

        this.getErrorMessage = function (err) {
            var errMsg = '';
            if (err.data && err.data.ExceptionMessage) {
                errMsg = err.data.ExceptionMessage;
            }
            return errMsg;
        };
    }]
);